/* eslint-disable no-param-reassign */
import { ChangeEvent } from 'react';

export const formatCardNumber = (event: ChangeEvent<HTMLInputElement>) => {
  const { value } = event.target;

  // Remove non-numeric characters
  const numericValue = value.replace(/\D/g, '');

  event.target.value = numericValue;

  return event;
};

export const formatExpiryDate = (event: ChangeEvent<HTMLInputElement>) => {
  const { value } = event.target;

  // Remove non-numeric characters
  const numericValue = value.replace(/\D/g, '');

  // Limit to four numeric characters
  const formattedValue = numericValue.slice(0, 4);

  // Add the '/' separator after the first two characters
  if (formattedValue.length > 2) {
    let month = formattedValue.slice(0, 2);
    const year = formattedValue.slice(2);

    if (Number(month) > 12) {
      month = '12';
    }

    event.target.value = `${month}/${year}`;

    return event;
  }

  event.target.value = formattedValue;

  return event;
};
